module.exports = __webpack_public_path__ + "img/p1-c3-p2.badeb6b8.jpg";